"use client";

import { useSearchParams } from "next/navigation";

/**
 * Get the current delivery mode from URL search params
 * @param searchParams - Next.js searchParams object
 * @returns "quick" if mode=quick_delivery, otherwise "normal"
 */
export const getDeliveryMode = (searchParams: URLSearchParams | null): "normal" | "quick" => {
  if (!searchParams) return "normal";
  const mode = searchParams.get("mode");
  return mode === "quick_delivery" ? "quick" : "normal";
};

/**
 * Get the delivery channel for API calls
 * @param searchParams - Next.js searchParams object
 * @returns "quick" if mode=quick_delivery, otherwise "normal"
 */
export const getDeliveryChannel = (searchParams: URLSearchParams | null): "normal" | "quick" => {
  return getDeliveryMode(searchParams);
};

/**
 * Hook to get current delivery mode
 * @returns "quick" if mode=quick_delivery, otherwise "normal"
 */
export const useDeliveryMode = (): "normal" | "quick" => {
  const searchParams = useSearchParams();
  return getDeliveryMode(searchParams);
};
